import { registerComponent } from '@gig/magic-common';
import ProfileComponent from './profile.vue.js';

var Profile = registerComponent(ProfileComponent);

export { Profile };
